import React from 'react';
import { Link } from 'react-router';
import cn from 'classnames';
import { Icon } from 'legacy-packages/ft-cb';
import { createWeightedStacks } from 'legacy-src/utility/progressHelpers';

import './styles.scss';

/**
 * PerformanceDetails
 * Display the list of students associated with each performance level category.
 */
const PerformanceDetails = ({
  stacks = [],
  studentUrl,
  title,
  footer,
  showFooter,
  id,
  showScore = true,
  isWeighted,
  disableNoResultsLink = false,
}) => {
  const stackWidth = `${100 / stacks.length}%`;
  const weightedStacks = createWeightedStacks(stacks, isWeighted);

  return (
    <div className="PerformanceDetails" id={id}>
      {title && <div className="title">{title}</div>}

      <div className="content">
        {weightedStacks.map((stack) => (
          <div
            key={stack.status}
            className="block"
            data-test-tier={stack.status}
            style={{
              width: stackWidth,
              flex: stack.flex,
            }}
          >
            <h5 className={cn('title', stack.status)}>
              {stack.label}
              <span className="info">
                {stack.students.length}
                <Icon name="person" size="15px" />
              </span>
            </h5>

            <div
              className={cn('list-wrapper', {
                '--columned': stack.hasExpandedView,
              })}
            >
              {stack.studentGroups.map((group, i, groups) => (
                <ul
                  data-test-student-group
                  className="list"
                  key={i}
                  style={{
                    width: `${100 / groups.length}%`,
                  }}
                >
                  {group &&
                    group.map((student) => {
                      const firstName = student.first_name || student.firstName;
                      const lastName = student.last_name || student.lastName;
                      const userId = student.user_id || student.id;
                      return (
                        <li
                          key={userId}
                          className="list-item"
                          data-test-tier-student={userId}
                        >
                          {studentUrl &&
                          !(stack.isNoResults && disableNoResultsLink) ? (
                            <Link
                              to={`${studentUrl}/${userId}`}
                              title={`${firstName} ${lastName}`}
                              onClick={(event) => event.stopPropagation()}
                            >
                              {firstName} {lastName}
                            </Link>
                          ) : (
                            <span>
                              {firstName} {lastName}
                            </span>
                          )}

                          {showScore && student.learnosityReport && (
                            <span className="link-info" data-test-score>
                              {student.learnosityReportScoreParsed}/
                              {student.learnosityReportMaxScore}
                            </span>
                          )}
                        </li>
                      );
                    })}
                </ul>
              ))}
            </div>
          </div>
        ))}
      </div>

      {showFooter && (
        <div className="footer" data-test-tier-footer>
          {footer}
        </div>
      )}
    </div>
  );
};

export default PerformanceDetails;
